<template>
    <!-- Toast Message -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false" />

      <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-award text-primary"></i> Awards</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
        <div class="col-md-3">
          <label class="form-label">Section
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
          <div class="col-md-3">
            <label class="form-label">
              Exam Type<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ examList.find(c => c._id === Obj.examID)?.Name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu">
                <li v-for="(item, index) in examList" :key="index" :value="item.Name">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.examID = item._id">
                    {{ item.Name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class="col-md-9 text-end">
          <button class="btn btn-sm btn-success me-1" @click="save()">
            <i class="fa fa-search text-white me-1"></i>Go
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      </div>
      <div class="row" v-if="tableshow">
        <div class="col-md-9 table-responsive mt-2">
         <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"  />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { api } from '@/utils/helpers.js';
import { ref, onMounted } from 'vue';
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList, examList } = schoolStore();
const Obj = ref({ clsID: "", sectionID: "", examID: "" });
const msgObj = ref({ msg: "", role: "", show: false });
const errors = ref({});
const tableshow = ref(false);
const students = ref([]);
const cols = ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Class', key: 'cls' },
  { label: 'ExamType', key: 'examName' },
  { label: 'Name', key: 'studentName' },
  { label: 'Total Marks', key: 'totalMarks' },
  { label: 'Rank', key: 'rank' }
]);
const rows = ref([]);
const progress = ref(0);
const reset = async () => {
  Obj.value = { clsID: "", sectionID: "", examID: "" };
  msgObj.value = { msg: "", role: "", show: false };
  errors.value = {};
  tableshow.value = false;
};
const save = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);

  const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired] },
    ExamType: { value: Obj.value.examID, validators: [isRequired] },
  };
  errors.value = validateForm(fields);

  if (Object.keys(errors.value).length === 0) {
    try {
      const res = await api.get(`/marks/all`);
      const data = res.data;
      let filtered = [];
      if (Obj.value.sectionID) {
        filtered = data.filter(m =>
          m.clsID === Obj.value.clsID &&
          m.sectionID === Obj.value.sectionID &&
          m.examID === Obj.value.examID
        );
      } else {
        filtered = data.filter(m =>
          m.clsID === Obj.value.clsID &&
          m.examID === Obj.value.examID
        );
      }

      if (filtered.length > 0) {
      const sorted = [...filtered].sort((a, b) => {
      const totalA = Object.values(a.subMarks[0] || {}).reduce((sum, val) => sum + val, 0);
      const totalB = Object.values(b.subMarks[0] || {}).reduce((sum, val) => sum + val, 0);
      return totalB - totalA;
    });
    let rank = 1;
    let prevTotal = null;

    const rankedRows = sorted.map((student, index) => {
      const totalMarks = Object.values(student.subMarks[0] || {}).reduce((a, b) => a + b, 0);
      if (prevTotal !== null && totalMarks !== prevTotal) {
        rank++;
      }

      prevTotal = totalMarks;

      return {
        Sno: index + 1,
        cls: `${clsList.value.find(c => c._id === student.clsID)?.name || ''}${
          secList.value.find(s => s._id === student.sectionID)?.Name
            ? ' (' + secList.value.find(s => s._id === student.sectionID)?.Name + ')'
            : ''}`,
        examName: examList.value.find(e => e._id === student.examID)?.Name || '',
        studentName: `${students.value.find(s => s._id === student.studentID)?.firstName || ''} ${students.value.find(s => s._id === student.studentID)?.lastName || ''}`,
        totalMarks,
        rank
      };
    });

    rows.value = rankedRows;
    tableshow.value = true;
      } else {
        rows.value = [];
        tableshow.value = false;
        msgObj.value = { msg: "Data not Found", role: "danger", show: true };
      }
    } catch (err) {
      msgObj.value = { msg: "Error fetching marks", role: "danger", show: true };
    } finally {
      progress.value = 0;
      clearInterval(progressInterval);
    }
  } else {
    clearInterval(progressInterval);
    progress.value = 0;
  }
};

onMounted(async () => {
  try {
    const res =  await api.get('/students/search?strat=0&limit=200');
    students.value = res.data;
  } catch (err) {
    console.error("Failed to fetch students", err);
  }
});
</script>
